import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LayoutManagerService} from './layout-manager.service';
import {Router} from '@angular/router';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import {CookieService} from 'ngx-cookie-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'assetstore';

  constructor(
    private layoutManagerService: LayoutManagerService,
    private translate: TranslateService,
    private snackBar: MatSnackBar,
    private cookieService: CookieService
  ) {
  }

  openSnackBar(message: string, action: string) {
    let config = new MatSnackBarConfig();
    if (this.layoutManagerService.mobileMode || this.layoutManagerService.smallMode)
      config.verticalPosition = 'top';
    else
      config.verticalPosition = 'bottom';
    config.horizontalPosition = 'center';
    config.duration = 500000;
    return this.snackBar.open(message, action, config);
  }

  ngOnInit(): void {
    this.layoutManagerService.updateSizes(window.innerWidth, window.innerHeight);
    this.translate.setDefaultLang('it');
    this.translate.use(this.translate.getBrowserLang());
    if(this.cookieService.get('accept-cookies')!='true') {
      let snackbarRef = this.openSnackBar('Per rendere la tua esperienza migliore' +
        ' questo sito fa uso di cookies, accetta per consentirne l\'utilizzo', 'Accetto');
      snackbarRef.onAction().subscribe(() => {
        const expiredDate = new Date();
        expiredDate.setDate( expiredDate.getDate() + 365 );
        this.cookieService.set('accept-cookies', 'true', expiredDate, '/', 'assetstore.assetx.it', false, 'Lax');
      });
    }
  }

}
